const frag = "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec2 vTextureCoord;\n\nuniform vec2 size;\nuniform sampler2D uSampler;\n\nuniform float uFreq;\nuniform float uAmp;\n\nuniform vec4 filterArea;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvec2 pixelate(vec2 coord, vec2 size)\n{\n\treturn floor( coord / size ) * size;\n}\n\nvec2 movePixels(vec2 coord)\n{\n    float t = gl_FragCoord.y / uFreq;\n    coord.x += sin( t ) * uAmp;\n    return coord;\n}\n\nvoid main(void)\n{\n\n    vec2 coord = mapCoord(vTextureCoord);\n\n    coord = pixelate(coord, size);\n\n    coord = unmapCoord(coord);\n\n    coord = movePixels(coord);\n\n    gl_FragColor = texture2D(uSampler, coord);\n}";

export default class PixelGlitchFilter extends PIXI.Filter {
    constructor(size = 10) {
        super(null, frag);
        this.size = size;
        this.uFreq = 0.01;
        this.uAmp = 0.02;
    }

    /**
     * This a point that describes the size of the blocks.
     * x is the width of the block and y is the height.
     *
     * @member {PIXI.Point|Array<number>|number}
     * @default 10
     */
    get size() {
        return this.uniforms.size;
    }

    /**
     * @param value
     */
    set size(value) {
        if (typeof value === 'number') {
            value = [value, value];
        }
        this.uniforms.size = value;
    }

    get uFreq() {
        return this.uniforms.uFreq;
    }

    set uFreq(value) {
        this.uniforms.uFreq = value;
    }

    get uAmp() {
        return this.uniforms.uAmp;
    }

    set uAmp(value) {
        this.uniforms.uAmp = value;
    }
}
